import $ from 'jquery'

function moveCursorToEnd(el) {
  if (el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA')) {
    const type = el.getAttribute('type') || 'text';
    const allowedTypes = ['text', 'search', 'password', 'tel', 'url', 'email', null];
    if (allowedTypes.includes(type) && typeof el.setSelectionRange === 'function') {
      const len = el.value.length;
      el.focus();
      el.setSelectionRange(len, len);
    } else {
      el.focus();
    }
  } else {
    el?.focus();
  }
}

function setupFocusHandlers() {
  const $inputs = $('.list-client-products .name-or-code-field input');
  if ($inputs.length > 0) {
    const $lastInput = $inputs.last();
    moveCursorToEnd($lastInput.get(0));
  }

  const $firstInput = $('.list-client-products:visible').first().find('input[type="text"]:visible');
  if ($firstInput.length) {
    moveCursorToEnd($firstInput.get(0));
  }

  $(document).on('keydown', function (e) {
    if (e.key !== 'Tab') return;

    const $scope = $('.list-client-products');
    const focusable = $scope
      .find('input, select, textarea, button, a[href], [tabindex]')
      .filter(':visible:not([disabled])')
      .toArray();

    const current = document.activeElement;
    const index = focusable.indexOf(current);
    if (index === -1) return;

    let nextIndex;
    if (e.shiftKey) {
      nextIndex = index === 0 ? focusable.length - 1 : index - 1;
    } else {
      nextIndex = index === focusable.length - 1 ? 0 : index + 1;
    }

    e.preventDefault();
    moveCursorToEnd(focusable[nextIndex]);
  });

  $(document).on('focusin', '.list-client-products .paginate-row a', function () {
    $(this).addClass('is-focused');
  });

  $(document).on('focusout', '.list-client-products .paginate-row a', function () {
    $(this).removeClass('is-focused');
  });

  $(document).on('ajax:complete', function () {
    setTimeout(() => {
      const $paginationLinks = $('.list-client-products .paginate-row a');
      if ($paginationLinks.length) {
        $paginationLinks.attr('tabindex', '0');
      }
    }, 100);
  });
}

$(document).on('turbolinks:load', setupFocusHandlers);
$(document).ready(setupFocusHandlers);

$(document).on('turbolinks:render', function () {
  $('.list-client-products .paginate-row a').off('focus').on('focus', function () {
    $(this).addClass('is-focused');
  }).off('blur').on('blur', function () {
    $(this).removeClass('is-focused');
  });
});

// Handle Line display toggle
$(document).on('click', '.js-toggle-line-display', function(e) {
  e.preventDefault();
  const $icon = $(this);
  const $hiddenField = $icon.siblings('.js-line-display-value');
  
  // Get current state
  const isCurrentlyOn = $icon.data('is-on') === 'true' || $icon.data('is-on') === true;
  const newState = !isCurrentlyOn;
  
  // Update the icon - use asset paths from data attributes
  const newImagePath = newState 
    ? $icon.data('image-on')
    : $icon.data('image-off');
  $icon.attr('src', newImagePath);
  
  // Update data attribute
  $icon.data('is-on', newState);
  
  // Update hidden field value
  $hiddenField.val(newState ? '1' : '0');
});